import { Checkbox, FormControlLabel } from "@mui/material";
import { ExternalThawInternalAction } from "../../../state/actions";
import { useExternalThawStateProvider } from "../../../state/StateProvider";

export const SplitEvenlyCheckBox = () => {
  const { externalThawInternalState, externalThawDispatch } =
    useExternalThawStateProvider();

  return (
    <FormControlLabel
      control={
        <Checkbox
          checked={
            !!externalThawInternalState.methodSettings.splitSeedingVolEvenly
          }
          onChange={(e) =>
            externalThawDispatch({
              type: ExternalThawInternalAction.SET_SPLIT_SEEDING_VOL_EVENLY,
              payload: {
                splitSeedingVolEvenly: e.target.checked ? true : false,
              },
            })
          }
          size="small"
        />
      }
      label={"Split Volume Evenly in Dest Plate"}
    />
  );
};
